export const iconFontAwesomeSecurityUserShield = (
	<i className="fa-solid fa-user-shield"></i>
);
